import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { getToken } from "../config/api";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  store.state.menuOpened = false;
  next();

  try {

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!getToken()) {
        next({
          name: "login",
          query: { redirect: to.fullPath }
        });
      } else {
        const user = await store.dispatch('getUser');
        if (user && user.locked_set === 1) {
          if (to.path !== '/kilit') {
            window.location.href = '/kilit';
          } 
        }
        next();
      }
    } else {
      next();
    }

    if (to.matched.some(record => record.meta.requiresAuthAdmin)) {
      const user = await store.dispatch('getUser');
      if (!getToken()) {
        next({
          name: "login",
          query: { redirect: to.fullPath }
        });
      } else if(user.homepage_permission == 0){
        localStorage.removeItem('access_token');
        next({
          name: "login",
          query: { redirect: to.fullPath }
        });
      } else {
        if (user && user.locked_set === 1) {
          if (to.path !== '/kilit') {
            window.location.href = '/kilit';
          } 
        }
        next();
      }
    } else {
      next();
    }

  } catch (e) {
  }

});

import { pageTitle } from '../config'
router.afterEach((to) => {
  const title = document.querySelector('title')
  const titleText = to.meta && to.meta.title ? `${to.meta.title} | ${pageTitle}` : pageTitle
  title.innerHTML = titleText
})

export default router;
